import { Controller } from "@hotwired/stimulus"

// Drives the Token History modal:
//   - Bucket filter: segmented control flips a
//     data-bucket-filter attribute on the wrapper. CSS does the actual hiding.
//   - Show-all: rows beyond the initial 50 carry .row-overflow and are
//     hidden by CSS. Clicking "Show all" sets data-show-all="true" on the
//     wrapper and hides the button itself.
//
// All state lives on the DOM via data attributes — no JS state, no
// re-rendering. Reset on modal close is handled by Bootstrap (the modal
// stays in the DOM, so state persists across opens; that's intentional).
export default class extends Controller {
  static targets = ["filterButton", "showAllButton"]

  filter(event) {
    const bucket = event.currentTarget.dataset.bucket
    this.element.dataset.bucketFilter = bucket
    this.filterButtonTargets.forEach((btn) => {
      const active = btn === event.currentTarget
      btn.classList.toggle("active", active)
      btn.setAttribute("aria-pressed", active.toString())
    })

    if (this.hasShowAllButtonTarget) {
      this.showAllButtonTarget.hidden = this.element.dataset.showAll === "true"
    }
  }

  showAll(event) {
    event.preventDefault()
    this.element.dataset.showAll = "true"
    if (this.hasShowAllButtonTarget) {
      this.showAllButtonTarget.hidden = true
    }
  }
}
